module.exports = __webpack_public_path__ + "img/word.b54f7334.svg";